import React from "react";
import * as Switch from "@radix-ui/react-switch";
import styles from "./SwitchToggle.module.css";

interface SwitchToggleProps {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

const SwitchToggle: React.FC<SwitchToggleProps> = ({
  label,
  checked,
  onCheckedChange,
  disabled = false,
}) => {
  return (
    <label className={styles.switchWrapper}>
      <Switch.Root
        className={`${styles.switchRoot} ${disabled ? styles.disabled : ""}`}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
      >
        <Switch.Thumb className={styles.switchThumb} />
      </Switch.Root>
      <span className={styles.toggleLabel}>{label}</span>
    </label>
  );
};

export default SwitchToggle;
